import { Button } from '@/view/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/view/components/ui/dropdown-menu'
import { ScrollArea } from '@radix-ui/react-scroll-area'
import { MoreHorizontal, Trash2, UserPen } from 'lucide-react'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PaginationCashfit } from '../../../../components/pagination-cashfit'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../components/ui/table'
import { convertParamsToJson, useCashfitParams } from '../../../../hooks/use-params'
import { deleteTemplate } from '../actions/delete-template'
import { loadTemplates } from '../actions/load-templates'

type ListTemplatesProps = {
  page: string
}

export function ListTemplates({ page }: ListTemplatesProps) {
  const [params] = useSearchParams()
  const { data: templates, reloadTemplates } = loadTemplates(Number(page))
  const { setParams } = useCashfitParams(convertParamsToJson(params))

  useEffect(() => {
    reloadTemplates()
  }, [params])

  return (
    <div className={'h-full'}>
      <ScrollArea className="h-container-contract-list p-1 overflow-y-auto">
        <Table className="overflow-hidden h-full">
          <TableHeader>
            <TableRow>
              <TableHead>Id</TableHead>
              <TableHead>Nome</TableHead>
              <TableHead>Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody className="">
            {templates?.data.data.content.map((template: any) => (
              <TableRow className="text-gray-600" key={template.id}>
                <TableCell>{template.id}</TableCell>
                <TableCell>{template.nome}</TableCell>
                <TableCell>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <span className="sr-only">Abrir Menu</span>
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="center">
                      <DropdownMenuLabel>Ações</DropdownMenuLabel>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem className="flex gap-2 cursor-pointer" onClick={() => setParams({ tabContentId: template.id, tabSelected: 'add-template' as any })}>
                        <UserPen height={24} width={30} className="text-blue-500 cursor-pointer p-1 hover:text-blue-400" />
                        Visualizar/Editar
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem className="flex gap-2 cursor-pointer" onClick={() => deleteTemplate(template.id, reloadTemplates)}>
                        <Trash2 height={24} width={30} className="text-red-500 cursor-pointer p-1 hover:text-red-400" />
                        Apagar
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
      <PaginationCashfit data={templates?.data.data} labelItem="templates" />
    </div>
  )
}
